var map = {
	"./02 1.png": 6384,
	"./04 (8) 1.png": 2239,
	"./Carousel/Carousel-Image.jpg": 9832,
	"./Carousel/Carousel-Image1.png": 7503,
	"./Carousel/Carousel-Image2.jpg": 9440,
	"./Carousel/Carousel-Image3.png": 3373,
	"./Carousel/banner-for-mobile.jpg": 119,
	"./Carousel/banner-for-mobile1.png": 9358,
	"./Carousel/banner-for-mobile2.jpg": 9573,
	"./Carousel/banner-for-mobile3.png": 9196,
	"./De-Stone.png": 118,
	"./DropUsALine.png": 2229,
	"./DropUsALine1.png": 7480,
	"./DropUsALineBottom.png": 928,
	"./Email.png": 8931,
	"./Established.png": 97,
	"./Facebook.png": 2927,
	"./Frame.png": 8564,
	"./Group 18.png": 1459,
	"./HuskAspiration.png": 2364,
	"./Husking.png": 2138,
	"./Infrastructure.png": 2222,
	"./Infrastructure1.png": 7301,
	"./Infrastructure2.png": 9470,
	"./InfrastructureProcess1.png": 2742,
	"./InfrastructureProcess2.png": 3949,
	"./InfrastructureProcess3.png": 2820,
	"./Instagram.png": 1863,
	"./Logo.png": 5926,
	"./OurProcess/Customer.png": 583,
	"./OurProcess/Distribution.png": 4521,
	"./OurProcess/Farming.png": 6419,
	"./OurProcess/Milling.png": 8653,
	"./OurProcess/Procurement.png": 5125,
	"./PaddySeparation.png": 4901,
	"./Parboiling.png": 1454,
	"./Phone.png": 2023,
	"./Polishing.png": 1130,
	"./Pre-Cleaning.png": 5522,
	"./Project (73) 1 (1).png": 6814,
	"./Quality1.png": 5123,
	"./Quality2.png": 9368,
	"./Quality3.png": 497,
	"./Quality4.png": 2782,
	"./SCCZC.png": 7055,
	"./Sorting&Grading.png": 5973,
	"./TwitterX.png": 8204,
	"./Weighing&Bagging.png": 9898,
	"./Whitening.png": 9758,
	"./about1.png": 4223,
	"./about2.png": 1764,
	"./about3.png": 9245,
	"./about4.png": 98,
	"./arrow.png": 4504,
	"./banner-about.png": 6429,
	"./bg-image1.png": 9626,
	"./bg-image2.png": 6038,
	"./bg-image3.png": 5055,
	"./bg-image4.png": 2832,
	"./bg-image6.png": 9346,
	"./bg-text.png": 9960,
	"./capacity.png": 4887,
	"./capacity1.png": 9518,
	"./capacity2.png": 1317,
	"./certified.png": 3372,
	"./cft.png": 642,
	"./contact-banner.png": 2988,
	"./dsgd.png": 9321,
	"./event-1.png": 7189,
	"./event-banner.png": 8616,
	"./event1.png": 3842,
	"./events/2025/evt-1.png": 20,
	"./events/2025/evt-10.png": 7982,
	"./events/2025/evt-11.png": 7479,
	"./events/2025/evt-12.png": 3548,
	"./events/2025/evt-13.png": 5813,
	"./events/2025/evt-14.png": 5386,
	"./events/2025/evt-2.png": 5135,
	"./events/2025/evt-3.png": 9942,
	"./events/2025/evt-4.png": 2361,
	"./events/2025/evt-5.png": 6112,
	"./events/2025/evt-6.png": 9931,
	"./events/2025/evt-7.png": 9426,
	"./events/2025/evt-8.png": 805,
	"./events/2025/evt-9.png": 8540,
	"./events/Event5.png": 568,
	"./events/event-1.png": 2715,
	"./events/event-10.png": 3971,
	"./events/event-11.png": 8762,
	"./events/event-12.png": 9345,
	"./events/event-2.png": 736,
	"./events/event-3.png": 8857,
	"./events/event-4.png": 8774,
	"./events/event-5.png": 5711,
	"./events/event-6.png": 8852,
	"./events/event-7.png": 2749,
	"./events/event-8.png": 4970,
	"./events/event-9.png": 9075,
	"./events/event4.png": 6801,
	"./events/ind/ind-1.png": 3874,
	"./events/ind/ind-10.png": 5944,
	"./events/ind/ind-11.png": 7073,
	"./events/ind/ind-12.png": 6490,
	"./events/ind/ind-13.png": 1699,
	"./events/ind/ind-14.png": 6828,
	"./events/ind/ind-15.png": 9717,
	"./events/ind/ind-16.png": 6977,
	"./events/ind/ind-17.png": 4935,
	"./events/ind/ind-18.png": 5024,
	"./events/ind/ind-2.png": 2057,
	"./events/ind/ind-3.png": 5152,
	"./events/ind/ind-4.png": 7999,
	"./events/ind/ind-5.png": 8982,
	"./events/ind/ind-6.png": 221,
	"./events/ind/ind-7.png": 9092,
	"./events/ind/ind-8.png": 5011,
	"./events/ind/ind-9.png": 6154,
	"./events/wellness.zip": 6293,
	"./export-house.png": 2974,
	"./fchcfvb.png": 3627,
	"./flag.png": 1869,
	"./founding-story.png": 6987,
	"./heritage.png": 6660,
	"./inkn.png": 8262,
	"./local.png": 2826,
	"./location.png": 4318,
	"./logo1.png": 2861,
	"./long-grain1.png": 1978,
	"./long-grain2.png": 961,
	"./long-grain3.png": 8248,
	"./long-grain4.png": 7863,
	"./mrmc-logo.png": 7744,
	"./non-basmati-rice1.png": 3075,
	"./non-basmati-rice2.png": 6216,
	"./non-basmati-rice3.png": 6161,
	"./non-basmati-rice4.png": 3694,
	"./our-pacakging.png": 5735,
	"./p1.png": 2674,
	"./p2.png": 7817,
	"./p3.png": 2992,
	"./p4.png": 1647,
	"./pro.png": 4858,
	"./pro1.png": 9529,
	"./pro3.png": 7099,
	"./pro8.png": 3848,
	"./process.png": 4908,
	"./product-banner.jpg": 959,
	"./product-labeling-banner.png": 9220,
	"./products/Hunar1.png": 9293,
	"./products/Hunar2.png": 8054,
	"./products/Hunar3.png": 7071,
	"./products/Hunar4.png": 4224,
	"./products/Hunar5.png": 1129,
	"./products/Yashas1.png": 1818,
	"./products/Yashas2.png": 1985,
	"./products/Yashas3.png": 4120,
	"./products/Yashas4.png": 9287,
	"./products/Yashas5.png": 974,
	"./products/Yashas6.png": 8325,
	"./rice.png": 1132,
	"./rice1.png": 3023,
	"./silder1.png": 5093,
	"./silder2.png": 2990,
	"./silder3.png": 679,
	"./silder4.png": 5512,
	"./silder5.png": 5457,
	"./slider1.png": 9767,
	"./slider2.png": 9132,
	"./slider3 1.png": 3948,
	"./slider3.png": 8549,
	"./slider4.png": 3882,
	"./slider5 1.png": 2234,
	"./slider5.png": 9091,
	"./slider6.png": 4600,
	"./social/s1.png": 6871,
	"./social/s2.png": 9292,
	"./social/s3.png": 5205,
	"./social/s4.png": 4778,
	"./story.png": 2852,
	"./test1.jpg": 2170,
	"./test2.jpg": 4245,
	"./test3.jpg": 9928,
	"./text-img.png": 9140,
	"./verified.png": 1671,
	"./vhjvi1.png": 9447,
	"./why-choose-us.png": 1022,
	"./why1.png": 8400,
	"./why2.png": 3435,
	"./why3.png": 4434,
	"./why4.png": 5997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;